export default __webpack_public_path__ + "static/media/792.33328bea.png";